import { createContext, useEffect, useState } from "react";
import { matchPath, useLocation } from "react-router-dom";

import "../node_modules/bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
 
import { AuthProvider } from "./AuthProvider";

import AppRoutes from "./routes/AppRoutes";
import { filter, indexOf, isEmpty, map } from "lodash";
import { Provider } from "react-redux";
import store from './store';
import { rtkStore } from "@/store/modern/index";
import AppInitializer from "./AppInitializer";
import { publicRoutePaths } from "./routes/public.routes.config";

export let property = createContext("");

const App = () => {

  const location = useLocation();
  const [selectedStore, setSelectedStore] = useState("");

  const pathArr = [publicRoutePaths.HOME.path, publicRoutePaths.ABOUT_US.path, publicRoutePaths.OUR_SERVICES.path,
  publicRoutePaths.GLOBAL_TRADE_NETWORK.path, publicRoutePaths.DIGITAL_PROMOTION.path, publicRoutePaths.CUSTOMER_SUPPORT.path, publicRoutePaths.FINANCIAL_PROTECTION.path, publicRoutePaths.BUSINESS_LEADS.path, publicRoutePaths.OUR_PRODUCTS.path, publicRoutePaths.JOIN_LOGISTIC.path, publicRoutePaths.BECOME_SUPPLIER.path,
  publicRoutePaths.LANDING_PAGE.path, publicRoutePaths.LANDING_PAGE_NOT_FOUND.path, publicRoutePaths.SUPPLIER_INQUIRY.path, publicRoutePaths.LOGISTIC_INQUIRY.path, publicRoutePaths.VIEW_ALL_INQUIRIES.path, publicRoutePaths.SEARCH_DETAIL.path, publicRoutePaths.EVENT_HIGHLIGHTS.path, publicRoutePaths.BLOG_LIST.path, publicRoutePaths.BLOG_DETAIL.path, publicRoutePaths.MARKET_PLACE.path, publicRoutePaths.MARKET_DETAIL.path, publicRoutePaths.PRODUCT_CATALOGUE.path, publicRoutePaths.COMPANY_CATALOGUE.path, publicRoutePaths.SEARCH_SUPPLIERS.path];

  useEffect(() => {
    //let matchedPath = map(pathArr => matchPath(route, location.pathname));
    let matcehdPath = map(pathArr, (route) => matchPath(route, location.pathname));
    matcehdPath = filter(matcehdPath);
    if (indexOf(pathArr, location.pathname) !== -1 || (!isEmpty(matcehdPath) && (location.pathname === matcehdPath[0].pathname))) {
      setSelectedStore("rtk");
    } else {
      setSelectedStore("legacy")
    }

  }, [location.pathname]);

  const getSelectedStore = (pathName) => {
    let matcehdPath = map(pathArr, (route) => matchPath(route, location.pathname));
    matcehdPath = filter(matcehdPath);
    if (indexOf(pathArr, pathName) !== -1 || (!isEmpty(matcehdPath) && (location.pathname === matcehdPath[0].pathname))) {
      return rtkStore;
    } else {
      return store();
    }
  }

  return (
    <Provider store={getSelectedStore(location.pathname)} key={`store_location_${location.pathname}`}>
      {
        selectedStore === "rtk" &&
        <AppInitializer>
          <AuthProvider key={`location_${location.pathname}`}>
            <AppRoutes />
          </AuthProvider>
        </AppInitializer>
      }
      {
        selectedStore === "legacy" && <AuthProvider key={`location_${location.pathname}`}> <AppRoutes /> </AuthProvider>
      }

    </Provider >
  );
}

export default App;
